"use strict";
/* tslint:disable */
var TResponsivePurchases = Object.assign({}, TBasePurchases, {
    buildInner: function (mode, purchase, context) {
        if (purchase.isEmpty() || purchase instanceof SPCashOutPurchase) {
            return '';
        } // dont display cashout bet receipts in the mobile for now
        var statusClass = Purchases.getStatusClass(purchase);
        var statusText = purchase.getStatusText();
        statusText += typeof purchase.getExternalIdText == 'function' ? purchase.getExternalIdText(' ') : '';
        context = context || {};
        var __html = '';
        __html += `
        <div class="bet-purchase-container ${Purchases.getStatus(purchase.PurchaseStatus)}" data-uat="bet-purchase-container">
            <div class="betSlip-bets-item purchase-list-status ${Purchases.getStatus(purchase.PurchaseStatus)}">
                <div class="betSlip-row-wrapper">
                    <div class="betSlip-row-content">
                        <div class="${statusClass} purchase-list-state" data-uat="bet-purchase-state">
                            ${statusText}
                        </div>
                        <div class="betSlip-row-desc">
                            <div class="betSlip-purchase-lines" data-uat="bet-purchase-description">
                                <strong>${purchase.getLinesDescription()}</strong>
                            </div>
                        </div>
                    </div>
                    <div class="betSlip-purchase-icon">`;
        if (Purchases.isWaitingStatus(purchase.PurchaseStatus)) {
            __html += ResponsiveHTMLTemplate.base.getTemplate('Loader').buildLoader('preloader-betslip');
        }
        else {
            __html += `<div class="icon i-16 i-c-betslip-purchase ${Purchases.getStatus(purchase.PurchaseStatus)}"></div>`;
        }
        __html += `
                    </div>
                </div>`;
        if (BetSlip.ShowBonusBettingMessage && purchase.BonusAmountStake > 0) {
            if (Purchases.isWaitingStatus(purchase.PurchaseStatus)) {
                __html += `<div class="betSlip-message betSlip-message-bonus" data-uat="bonus-message">${$dict.bs("BonusBettingMessage")}</div>`;
            }
            else if (Purchases.isAcceptedStatus(purchase.PurchaseStatus)) {
                __html += `<div class="betSlip-message betSlip-message-bonus" data-uat="bonus-message">${$dict.bs("BonusBettingReceiptMessage")}</div>`;
            }
        }
        __html += `
            </div>
            ${this.createLinesList(mode, purchase, context)}
            ${this.createBetsList(mode, purchase, context)}
        </div>`;
        return __html;
    },
    createLinesListInner: function (mode, selections, context) {
        var selection, i, len, selectionType, keys = Object.keys(selections), skipEW = true, prevCombinatorGroup = "";
        var shouldShowOdds = !Modes.isTeaserMode(mode);
        if (BetSlip.isCombinatorMode(mode)) {
            selections.sort(function (a, b) { return a.compareCombinatorGroup(b, true); });
        }
        context.shouldShowEW = true;
        var __html = '';
        for (i = 0, len = keys.length; i < len; i += 1) {
            selection = selections[keys[i]];
            selectionType = BetSlipUtil.getSelectionType(selection);
            if (BetSlip.isCombinatorMode(mode) && prevCombinatorGroup !== selection.CombinatorGroup) {
                prevCombinatorGroup = selection.CombinatorGroup;
                var header = "{0} {1}:".format($dict.bs("CombinatorGroup"), prevCombinatorGroup);
                __html += `<div class="betSlip-purchase-group heading">${header}</div>`;
            }
            __html += `
            <div class="betSlip-bets-item placed purchase-line" data-uat="bet-purchase-selection">
                <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                    <div class="betSlip-row-content">
                        <div class="betSlip-title-count">
                            <strong>`;
            __html += TSelections[selectionType].buildPick(mode, selection, context, selections);
            __html += `
                            </strong>`;
            if (shouldShowOdds) {
                __html += TSlipShared.createPickLineOdds(mode, selection, context, skipEW);
            }
            __html += `
                        </div>
                        <div class="betSlip-bet-desc">
                            ${TSelections[selectionType].buildDescription(mode, selection, context, selections)}
                            ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                        </div>
                    </div>
                </div>
            </div>`;
        }
        return __html;
    },
    createBetsListInner: function (mode, bets, context, purchase) {
        var bet, i, len, selection, keys = Object.keys(bets), selections, totalReturn, summary, taxesOnReturn;
        var __html = '';
        for (i = 0, len = keys.length; i < len; i += 1) {
            bet = bets[keys[i]];
            if (bet.skip && bet.skip(context)) {
                continue;
            }
            summary = context.VariationSummary;
            totalReturn = summary ? summary.maxWin : bet.getTotalGain();
            totalReturn = (bet.Selection && bet.Selection.EachWayIncluded) ? bet.getTotalGainEW() : totalReturn;
            taxesOnReturn = UserInfo.TaxProvider.getPurchaseTicketTaxAmount(totalReturn);
            //Ugly hack for forecast/tricast
            if (bet instanceof SPMultiLineBet) {
                selections = bet.ChildSelections;
            }
            var hasComboBonusClass = Purchases.hasComboBonus(bet) ? "hasComboBonus" : "";
            __html += `
            <div class="betSlip-bets-item placed purchase-receipt" data-uat="bet-purchase-receipt">
                <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                    <div class="betSlip-row-content ${hasComboBonusClass}">
                        <div class="betSlip-bet-title" data-uat="bet-purchase-bet-name">                            
                            ${this.createBetTitle(bet)}
                            ${this.buildPick(mode, selection, context, selections, bet, purchase)}
                            ${this.buildComboBonusInfo(bet)}
                        </div>
                        <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                            ${this.buildDescription(mode, selection, context, selections, bet, purchase)}
                            <div class="winnings">
                                <strong>${$dict.bs("Stake")}:</strong>`;
            if (BetSlip.ShowNumberOfBetAfterSinglePurchaseOnMobile) {
                __html +=
                    `<span data-uat="bet-purchase-show-names">${$dict.bs("SingleNamesOneBet")} x</span>`;
            }
            __html += `
                                <span class="betSlip-deposit-odds">
                                    ${this.createBetDeposit(bet, context)}
                                    ${this.createBetOdds(mode, bet, context)}
                                </span>
                                <div class="betSlip-freebet-stake" data-uat="bet-purchase-free-bet">
                                    ${this.createFreeBetStake(bet, context)}
                                </div>
                                <strong>${$string("BettingHistory").Return}:</strong>
                                <span class="betSlip-return" data-uat="bet-purchase-total-return">${bet.getReturn(context)}</span>`;
            if (taxesOnReturn) {
                var returnAfterTaxes = context.HasSP ? $dict.bs("NotAvailable") : (totalReturn - taxesOnReturn).toFixed(2);
                __html += `
                                        <div data-uat="bet-purchase-tax-amount">${($dict.bs("RegulatoryTax")).format(UserInfo.TaxProvider.TaxInfo.CountryTax)}: ${UserInfo.current.toUserFormatedCurrencyString(taxesOnReturn)}</div>
                                        <div data-uat="bet-purchase-return-after-taxes">${$dict.bs("ReturnAfterTax")}: ${UserInfo.current.toUserFormatedCurrencyString(returnAfterTaxes)}</div>`;
            }
            __html += `
                                ${this.buildTaxOnDeposit(bet)}
                            </div>
                        </div>
                        ${this.buildLoyaltyPoints(bet)}
                    </div>
                </div>
            </div>`;
        }
        __html += this.createNewOfferActions(bet);
        return __html;
    },
    createNewOfferActions: function (bet) {
        if (!Purchases.isNewOfferStatus(bet)) {
            return "";
        }
        return `
        <div class="line-actions">
            <div class="betSlip-btn-holder">
                <a href="javascript:UniSlipBlock.declineOffer('${bet.RowID}');" class="flatBtn negative betSlip-btn" data-uat="bet-purchase-cancel-new-offer">${$dict.bs("Cancel")}</a>
            </div>
            <div class="betSlip-btn-holder">
                <a href="javascript:UniSlipBlock.acceptOffer('${bet.RowID}');" class="flatBtn positive betSlip-btn" data-uat="bet-purchase-accept-new-offer">${$dict.bs("Accept")}</a>
            </div>
        </div>`;
    }
});
window.TResponsivePurchases = TResponsivePurchases;
jsRequire("/templates/Mobile/UniSlip/Purchases/TResponsivePurchases.ext.js");
//# sourceMappingURL=TResponsivePurchases.js.map